<p-card>
  <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-4">Firmeninformation / Rechnungsadresse</div>
  <ow-business-data-form (updateValidity)="updateValidity('business-data', $event)"></ow-business-data-form>
  <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mt-4 mb-4">Ansprechpartner</div>
  <ow-contact-person-form (updateValidity)="updateValidity('contact-person', $event)"></ow-contact-person-form>
  <div class="text-lg font-semibold  border-bottom-2 border-cyan-500 mt-4 mb-4">Ihre Bankdaten</div>
  <ow-business-banking-form (updateValidity)="updateValidity('business-banking', $event)"></ow-business-banking-form>
  <div class="text-lg font-semibold  border-bottom-2 border-cyan-500 mt-4 mb-4">Ihr neuer Anschluss</div>
  <ow-business-porting-form (updateValidity)="updateValidity('porting', $event)"></ow-business-porting-form>
  <div class="text-lg font-semibold  border-bottom-2 border-cyan-500 mt-4 mb-4">Telefonbuch & Einzelverbindungsnachweis</div>
  <ow-phone-book-form (updateValidity)="updateValidity('phone-book', $event)"></ow-phone-book-form>
  <div class="grid mt-4">
    <div class="col-6">
        <button type="button" pButton label="zurück" (click)="prevStep()" class="p-button-secondary"></button>
    </div>
    <div class="col-6">
        <button type="button" pButton label="weiter" (click)="nextStep()" class="p-button-primary w-full" [disabled]="!isValid()"></button>
    </div>
  </div>
</p-card>
